module.exports = __webpack_public_path__ + "img/logo-tazapay.92b63562.svg";